import { render, staticRenderFns } from "./input-dropdown.vue?vue&type=template&id=4725a2f5&scoped=true&"
import script from "./input-dropdown.vue?vue&type=script&lang=js&"
export * from "./input-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725a2f5",
  null
  
)

export default component.exports